import UserHeader from '../dashboard/UserHeader';

const HelpCenter = () => {
  return (
    <div className="setting toggle-sidebar">
      <UserHeader />
      <div id="main" className="main">
        <div className="group-breadcrumb">
          <div className="breadcrumb-left">
            <ul>
              <li>
                <a href="/dashboard">Dashboard</a>
              </li>
              <li>
                <strong>Help Center</strong>
              </li>
            </ul>
            <h1>Help Center</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
